import { React, useEffect, useState } from "react";
import { useGlobalContext } from "../context";
import Board from "./Board";
let stockfish = new Worker("stockfish11.js");

const Chess960Board = ({ chess, casltingFigures }) => {
  const {
    setPgn,
    setFen,
    setIsGameOver,
    piecesColor,
    resetBoard,
    engineStrength,
    newChess960Game,
    setNewChess960Game,
  } = useGlobalContext();

  const [fullPgn, setFullPgn] = useState([]);

  useEffect(() => {
    if (newChess960Game) {
      setPgn("");
      setFullPgn([]);
      setNewChess960Game(false);
    } else {
      let counter = 1;
      let pgnString = "";
      fullPgn.map((item, index) => {
        if (index % 2 === 0) {
          pgnString += counter + ". ";
          counter++;
        }
        pgnString += item + " ";
      });
      setPgn(pgnString);
    }
  }, [fullPgn, newChess960Game]);

  const [engineSettings, setEngineSettings] = useState({
    skillLevel: 0,
    skillError: 900,
    skillProbability: 10,
  });

  const setEngineValues = (skillLevel, skillError, skillProbability) => {
    setEngineSettings({
      skillLevel,
      skillError,
      skillProbability,
    });
  };

  useEffect(() => {
    if (engineStrength == 800) {
      setEngineValues(0, 500, 10);
    } else if (engineStrength == 900) {
      setEngineValues(0, 200, 10);
    } else if (engineStrength == 1000) {
      setEngineValues(0, 200, 70);
    } else if (engineStrength == 1100) {
      setEngineValues(0, 200, 128);
    } else if (engineStrength == 1200) {
      setEngineValues(2, 200, 128);
    } else if (engineStrength == 1300) {
      setEngineValues(3, 200, 128);
    }
  }, []);

  const [castlingRights, setCastlingRights] = useState({
    queenRights: false,
    kingRights: false,
  });

  const [fenCastlingRights, setFenCastlingRights] = useState("KQkq");

  useEffect(() => {
    if (fenCastlingRights.length === 0) {
      setFenCastlingRights("-");
    }
  }, [fenCastlingRights]);

  const updateFenCastlingRights = () => {
    let fen = chess.fen();
    fen = fen.split(" ");
    fen[2] = fenCastlingRights;
    fen = fen.join(" ");
    return fen;
  };

  // make computer move (stockfish 11)
  const computerMove = () => {
    let fen = updateFenCastlingRights();
    stockfish.postMessage("uci");
    stockfish.postMessage(
      `setoption name Skill Level value ${engineSettings.skillLevel}`
    );
    stockfish.postMessage(
      `setoption name Skill Level Maximum Error value ${engineSettings.skillError}`
    );
    stockfish.postMessage(`setoption name UCI_Chess960 value true`);
    stockfish.postMessage(
      `setoption name Skill Level Probability value ${engineSettings.skillProbability}`
    );
    stockfish.postMessage("ucinewgame");
    stockfish.postMessage(`position fen ${fen}`);
    stockfish.postMessage(`go depth 1`);
    stockfish.onmessage = (e) => {
      let data = JSON.stringify(e.data);
      if (data.startsWith('"bestmove')) {
        let move = data.split(" ")[1];
        let from = move.slice(0, 2);
        let to = move.slice(2, 4);
        let last = "";
        setTimeout(() => {
          if (chess.move({ from: from, to: to, promotion: "q" })) {
            last = chess.history()[chess.history().length - 1];
          } else {
            if (from > to) {
              makeCastlingMove(from, to, false, !piecesColor);
              last = "O-O-O";
            } else {
              makeCastlingMove(from, to, true, !piecesColor);
              last = "O-O";
            }
          }
          fetch("https://chess-tutor-api.herokuapp.com/get_castle_rights/", {
            method: "POST",
            credentials: "omit",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              fen: updateFenCastlingRights(),
              queenside: casltingFigures.king + casltingFigures.rook1,
              kingside: casltingFigures.king + casltingFigures.rook2,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              setCastlingRights({
                queenRights: data.queen_right,
                kingRights: data.king_right,
              });
              setFullPgn((prevState) => [...prevState, last]);
              setFen(chess.fen());
              if (chess.game_over()) {
                setIsGameOver(true);
              }
            });
        }, 3000);
      }
    };
  };

  // if user is black, make computer move first
  useEffect(() => {
    setTimeout(() => {
      if (
        (piecesColor && chess.turn() === "b") ||
        (!piecesColor && chess.turn() === "w")
      ) {
        computerMove();
      }
    }, 1000);
  }, [resetBoard, piecesColor, chess]);

  const updateFenAfterCastling = () => {
    let fenToLoad = chess.fen();
    fenToLoad = fenToLoad.split(" ");
    chess.turn() === "w" ? (fenToLoad[1] = "b") : (fenToLoad[1] = "w");
    fenToLoad[3] = "-";
    fenToLoad = fenToLoad.join(" ");
    chess.load(fenToLoad);
  };

  const makeCastlingMove = (from, to, kingSide, color = piecesColor) => {
    let number;
    color ? (number = "1") : (number = "8");
    let rook = chess.get(to);
    let king = chess.get(from);

    if (chess.remove(from) && chess.remove(to)) {
      if (kingSide) {
        chess.put(king, "g" + number);
        chess.load(chess.fen());
        chess.put(rook, "f" + number);
        color
          ? setFenCastlingRights(fenCastlingRights.replace("K", ""))
          : setFenCastlingRights(fenCastlingRights.replace("k", ""));
      } else {
        chess.put(king, "c" + number);
        chess.load(chess.fen());
        chess.put(rook, "d" + number);
        color
          ? setFenCastlingRights(fenCastlingRights.replace("Q", ""))
          : setFenCastlingRights(fenCastlingRights.replace("q", ""));
      }
    }

    chess.load(chess.fen());
    updateFenAfterCastling();
  };

  // handle user's turn and make a computer move
  const handleMove = (from, to) => {
    let last = "";
    if (chess.move({ from, to, promotion: "q" })) {
      let history = chess.history();
      last = history[history.length - 1];
    } else if (from === casltingFigures.king && to === casltingFigures.rook1) {
      makeCastlingMove(from, to, false);
      last = "O-O-O";
    } else if (from === casltingFigures.king && to === casltingFigures.rook2) {
      makeCastlingMove(from, to, true);
      last = "O-O";
    }
    setFullPgn((prevState) => [...prevState, last]);
    setFen(chess.fen());
    computerMove();
  };

  // show and let valid moves for users color
  const calcMovable = () => {
    const dests = new Map();
    chess.SQUARES.forEach((s) => {
      const ms = chess.moves({ square: s, verbose: true });
      if (ms.length)
        dests.set(
          s,
          ms.map((m) => m.to)
        );
    });

    let kingPos = chess.SQUARES.indexOf(casltingFigures.king);
    let castles = [];
    if (castlingRights.queenRights) {
      castles.push(casltingFigures.rook1);
    }
    if (castlingRights.kingRights) {
      castles.push(casltingFigures.rook2);
    }
    let kingDests = dests.get(casltingFigures.king);
    if (kingDests) {
      if (kingDests.includes(chess.SQUARES[kingPos - 2])) {
        kingDests.splice(kingDests.indexOf(chess.SQUARES[kingPos - 2]), 1);
      }
      if (kingDests.includes(chess.SQUARES[kingPos + 2])) {
        kingDests.splice(kingDests.indexOf(chess.SQUARES[kingPos + 2]), 1);
      }
      dests.set(casltingFigures.king, kingDests.concat(castles));
    } else {
      dests.set(casltingFigures.king, castles);
    }

    return {
      free: false,
      dests,
      color: piecesColor ? "white" : "black",
    };
  };

  return (
    <>
      <Board chess={chess} handleMove={handleMove} calcMovable={calcMovable} />
    </>
  );
};

export default Chess960Board;
